import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import { getPositions } from '../../services/tradingApi';

const statusColor = (s) => {
  if (s === 'open') return '#4caf50';
  if (s === 'closed_win') return '#4caf50';
  if (s === 'closed_loss') return '#f44336';
  return '#888';
};

const Positions = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('open');

  useEffect(() => {
    const fetch = async () => {
      try {
        const params = {};
        if (statusFilter) params.status = statusFilter;
        const { data } = await getPositions(params);
        setPositions(data);
      } catch (err) {
        console.error('Error fetching positions:', err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [statusFilter]);

  return (
    <div style={{ padding: '1rem', maxWidth: '1200px' }}>
      <h2 style={{ color: 'white', marginBottom: '20px' }}>Positions</h2>

      <div style={{ marginBottom: '15px' }}>
        <Form.Select
          size="sm"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{ width: '160px', backgroundColor: '#111', color: 'white', border: '1px solid #444' }}
        >
          <option value="open">Open</option>
          <option value="">All</option>
          <option value="closed_win">Closed (Win)</option>
          <option value="closed_loss">Closed (Loss)</option>
          <option value="closed_push">Closed (Push)</option>
        </Form.Select>
      </div>

      {loading ? (
        <div style={{ color: 'white' }}>Loading...</div>
      ) : positions.length === 0 ? (
        <div style={{ color: '#888', padding: '20px' }}>No positions found</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <Table bordered size="sm" style={{ backgroundColor: 'black', color: 'white', fontSize: '13px' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #444' }}>
                <th>Market</th>
                <th>Fixture</th>
                <th>Type</th>
                <th>Side</th>
                <th>Contracts</th>
                <th>Avg Price</th>
                <th>Cost</th>
                <th>Potential Payout</th>
                <th>P&L</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {positions.map((p) => (
                <tr key={p.id} style={{ borderBottom: '1px solid #222' }}>
                  <td style={{ fontFamily: 'monospace', fontSize: '12px' }}>{p.kalshi_market_ticker}</td>
                  <td>{p.fixture_summary}</td>
                  <td>{p.bet_type}</td>
                  <td>{p.side?.toUpperCase()}</td>
                  <td>{p.total_contracts}</td>
                  <td>{parseFloat(p.avg_price).toFixed(1)}¢</td>
                  <td>${parseFloat(p.total_cost).toFixed(2)}</td>
                  <td>${parseFloat(p.total_potential_payout).toFixed(2)}</td>
                  <td style={{ color: p.realized_pnl >= 0 ? '#4caf50' : '#f44336' }}>
                    {p.realized_pnl != null ? `$${parseFloat(p.realized_pnl).toFixed(2)}` : '--'}
                  </td>
                  <td style={{ color: statusColor(p.status) }}>{p.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default Positions;
